import { render, staticRenderFns } from "./PostulacionExport.vue?vue&type=template&id=526b3331"
import script from "./PostulacionExport.vue?vue&type=script&lang=js"
export * from "./PostulacionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports